export function useLocales() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const items: string = (window as any)._env_.REACT_APP_LOCALES;

  return {
    locales: items?.split(',') || [],
  };
}
